import * as React from 'react'

const ArrowDown = props => {
  return (
    <svg width={20} height={12} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10l-1.393-1.435L11 16.172V0H9v16.172L1.414 8.586 0 10l10 10 10-10z"
        fill="#304A3D"
      />
    </svg>
  )
}

export default ArrowDown
